import { render, staticRenderFns } from "./IconCopy.vue?vue&type=template&id=344cb593"
import script from "./IconCopy.vue?vue&type=script&lang=js"
export * from "./IconCopy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports